<template>
  <div>
    <GmapMarker
      v-if="place.location"
      :position="position"
      :draggable="false"
      :icon="icon()"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { gmapApi } from 'vue2-google-maps'

export default {
  computed: {
    ...mapGetters({
      place: 'map/getSpalMarker'
    }),
    google: gmapApi,
    position: function () {
      return {
        lat: this.place.location.latitude,
        lng: this.place.location.longitude
      }
    }
  },
  methods: {
    icon: function () {
      if (this.google) {
        // TODO: APIから取得するようにする
        return {
          url: 'https://sendai2.jre-maas.com/mapicons/pin_spal@3x.png',
          scaledSize: new this.google.maps.Size(62, 62)
        }
      }
    }
  }
}
</script>
